import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Transition } from "@headlessui/react";
import '../css/mycss/main.css'
import { AuthContext } from '../AuthContext'

function Header() {

  const history = useHistory();
  const location = useLocation();

  const { currentUser, signOutUser, getTeamsSubscription } = useContext(AuthContext);

  const [top, setTop] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  function onSignOutClick() {
    signOutUser()
    history.push('/')
  }

  async function goProfile() {

    if (location.pathname === '/playground') {
      history.push('/profile'); // Redirect to profile first
      return;
    }

    if (currentUser) {
      // if already subbed to teams
      let teamsSub = await getTeamsSubscription(currentUser.email)
      if (teamsSub && teamsSub.tier && teamsSub.tier >= 1) {
          history.push('/teams/settings/profile')
          return
      }
    }
    
    history.push('/profile')
  }

  function goAppInstall() {
    // google tracking
    try {
      // Send the trial start event to Google Analytics (and ultimately Google Ads) after the user is successfully created
      window.gtag && window.gtag('event', 'app_button_click', {
        'event_category': 'Button Click',
        'event_label': 'App Button Click',
        'value': 0.1
      });
      console.log('App Button Click')
    } catch (error) {
      console.log('Error in tracking app button click start in Google Analytics', error);
    }

    history.push('/app-install')
  }

  function goSignup() {

    // google tracking
    try {
      // Send the trial start event to Google Analytics (and ultimately Google Ads) after the user is successfully created
      window.gtag && window.gtag('event', 'web_button_click', {
        'event_category': 'Button Click',
        'event_label': 'Web Button Click',
        'value': 0.1
      });
      console.log('Web Button Click')
    } catch (error) {
      console.log('Error in tracking web button click start in Google Analytics', error);
    }

    history.push('/signup')
  }

  function goExtension() {
    window.open("https://chrome.google.com/webstore/detail/routora-google-maps-route/jdddfnfohdeaklgkpglonlofgapjgfbp", '_blank').focus();
  }

  // detect whether user has scrolled the page down by 10px 
  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true)
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [top]); 

  // change bg color on grid section
  // useEffect(() => {
  //   const targetDiv = document.getElementById('main-webgrid'); // Replace with your target div's id
  //   const changeHeaderBackground = () => {
  //     const header = document.getElementById('main-header'); // Replace with your header's id
  //     if (window.pageYOffset >= targetDiv.offsetTop) {
  //       header.classList.add('header-bg-new-color'); // Add a new class for the new background
  //     } else {
  //       header.classList.remove('header-bg-color');
  //     }
  //   };
  
  //   window.addEventListener('scroll', changeHeaderBackground);
  
  //   return () => {
  //     window.removeEventListener('scroll', changeHeaderBackground);
  //   };
  // }, []); // Empty array ensures effect runs only once on mount
  useEffect(() => {
    const changeHeaderBackground = () => {
      const targetDiv = document.getElementById('main-webgrid'); // The ID of the div that triggers the color change
      const header = document.getElementById('main-header'); // The ID of your header
      const menu = document.getElementById('header-menu'); // menu of header
      const headerSignin = document.getElementById('header-signin'); // sign in button
      const headerCorner = document.getElementById('corner-button'); // corner button/profile
      const mobileMenu = document.getElementById('mobile-menu-button'); // mobile menu button
  
      // Check if the elements exist in the DOM
      if (targetDiv && header) {
        const targetDivRect = targetDiv.getBoundingClientRect();
        const headerRect = header.getBoundingClientRect();
        
        // Check if the header's bottom passes the top of the target div and if the header's top is above the bottom of the target div
        if (window.scrollY + headerRect.bottom > targetDivRect.top + window.scrollY &&
            window.scrollY + headerRect.top < targetDivRect.bottom + window.scrollY) {
          header.classList.add('header-bg-new-color'); // Add class to change color
          if (menu) menu.classList.add('header-text-new-color');
          if (headerSignin) headerSignin.classList.add('header-signin-new-color');
          if (headerCorner) headerCorner.classList.add('corner-button-new-color');
          if (mobileMenu) mobileMenu.classList.add('menu-button-new-color');
        } else {
          header.classList.remove('header-bg-new-color'); // Remove class to revert color
          if (menu) menu.classList.remove('header-text-new-color');
          if (headerSignin) headerSignin.classList.remove('header-signin-new-color');
          if (headerCorner) headerCorner.classList.remove('corner-button-new-color');
          if (mobileMenu) mobileMenu.classList.remove('menu-button-new-color');
        }

      }
    };
    
    window.addEventListener('scroll', changeHeaderBackground);
    
    // Clean up the event listener when the component unmounts
    return () => window.removeEventListener('scroll', changeHeaderBackground);
  }, []); // Empty dependency array to ensure effect runs only on mount and unmount


  async function goTeams() {
    if (currentUser) {
      // if already subbed to teams
      let teamsSub = await getTeamsSubscription(currentUser.email)
      if (teamsSub && teamsSub.tier && teamsSub.tier >= 1) {
          history.push('/teams')
          return
      }
    }

    history.push('/teams-intro')
  }
  
  
  
  let userText = ''
  let userFirstChar = ''
  if (currentUser) {
      if (currentUser.displayName) {
        userText = 'Hello ' + currentUser.displayName
        if (currentUser.displayName.includes(' ')) {
          userText = 'Hello ' + currentUser.displayName.split(' ')[0]
        }
        userFirstChar = currentUser.displayName.charAt(0)
      }
  }

  return (
    <header>
      <nav id="main-header" className={`header-bg-color fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ${!top && 'bg-white blur shadow-lg'}`}>
        <div className="max-w-6xl mx-auto px-5 sm:px-6">
          <div className="flex items-center justify-between h-16 md:h-20">
              <div className="flex w-2/6 flex-grow justify-left flex-wrap items-center">
                <div className="flex-shrink-0">
                  <Link to="/" className="block" aria-label="Cruip">
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 md:mt-0" id="svg" version="1.1" width="108" height="60.75" viewBox="0, 0, 400, 225"><g id="svgg"><path id="path0" d="M195.905 58.134 C 194.094 58.492,192.262 59.787,191.340 61.359 C 190.370 63.014,190.216 64.486,190.212 72.109 L 190.208 79.113 187.969 79.218 C 183.426 79.431,181.141 81.815,181.865 85.587 C 182.374 88.236,184.163 89.519,187.833 89.864 L 190.189 90.085 190.268 107.386 C 190.337 122.527,190.390 124.909,190.696 126.458 C 192.262 134.385,196.564 137.311,206.640 137.303 C 216.482 137.295,221.380 134.862,221.342 130.000 C 221.308 125.662,218.809 124.344,212.636 125.408 C 208.942 126.044,207.946 125.911,206.641 124.607 C 205.093 123.058,205.131 123.508,205.049 105.812 L 204.976 90.062 207.853 89.913 C 214.443 89.572,216.669 88.239,216.666 84.638 C 216.662 80.542,214.610 79.167,208.504 79.167 L 205.000 79.167 205.000 72.723 C 205.000 65.622,204.817 63.551,204.048 61.950 C 202.677 59.096,199.222 57.477,195.905 58.134 M18.021 77.845 C 14.283 78.289,12.364 80.755,11.880 85.733 C 11.612 88.483,11.606 127.667,11.872 130.000 C 12.533 135.787,16.909 138.754,21.982 136.856 C 26.115 135.310,26.667 133.378,26.667 120.447 C 26.667 93.509,29.712 87.999,42.504 91.797 C 46.653 93.028,48.658 92.706,50.606 90.493 C 55.378 85.071,48.873 77.961,39.063 77.876 C 33.612 77.829,30.734 79.503,27.212 84.771 L 26.042 86.522 26.039 85.605 C 26.021 80.498,22.705 77.289,18.021 77.845 M78.307 77.928 C 63.293 79.007,53.505 89.049,52.267 104.643 C 50.822 122.844,61.701 136.293,78.646 137.254 C 97.516 138.324,109.796 127.349,110.353 108.917 C 110.840 92.818,102.839 81.644,88.606 78.544 C 87.031 78.201,81.496 77.636,80.729 77.740 C 80.615 77.756,79.525 77.840,78.307 77.928 M127.130 77.940 C 124.100 78.445,122.109 80.535,121.458 83.893 C 121.034 86.083,121.284 120.263,121.741 122.604 C 123.511 131.658,129.547 136.751,139.063 137.220 C 146.662 137.594,152.228 135.361,157.570 129.795 L 159.583 127.698 159.586 129.318 C 159.600 138.916,171.812 140.634,173.321 131.250 C 173.673 129.061,173.605 85.955,173.246 83.945 C 171.934 76.594,162.143 75.386,159.366 82.233 L 158.877 83.438 158.729 97.083 C 158.557 113.023,158.317 116.123,157.072 118.565 C 152.907 126.729,141.541 128.164,138.025 120.970 C 136.324 117.490,136.228 116.410,136.064 98.750 L 135.921 83.438 135.429 82.233 C 134.327 79.535,130.749 77.268,128.333 77.737 C 128.276 77.748,127.735 77.839,127.130 77.940 M249.271 77.917 C 234.038 79.056,224.353 88.980,223.116 104.716 C 221.448 125.945,236.569 140.098,257.582 136.978 C 272.779 134.721,281.705 123.072,281.184 106.177 C 280.617 87.819,267.866 76.527,249.271 77.917 M298.214 77.918 C 295.368 78.329,293.579 80.252,292.752 83.790 C 292.263 85.882,292.202 129.543,292.685 131.458 C 294.758 139.673,305.606 139.333,307.056 131.009 C 307.206 130.144,307.292 126.453,307.294 120.816 C 307.299 93.492,310.369 87.904,323.229 91.815 C 327.241 93.035,329.291 92.697,331.227 90.498 C 336.079 84.986,329.468 77.889,319.479 77.886 C 314.145 77.884,311.298 79.585,307.746 84.896 L 306.771 86.354 306.626 85.040 C 306.028 79.620,303.171 77.201,298.214 77.918 M357.314 77.946 C 346.562 79.070,338.871 84.283,337.377 91.458 C 336.378 96.259,338.755 99.271,343.542 99.271 C 346.483 99.271,346.591 99.200,348.957 95.731 C 353.097 89.662,355.565 88.301,362.500 88.264 C 368.692 88.230,371.054 89.413,372.498 93.271 C 372.988 94.582,373.666 98.333,373.494 98.781 C 373.286 99.325,365.307 101.300,352.500 103.976 C 340.016 106.586,334.992 111.062,334.633 119.896 C 333.919 137.457,355.420 143.302,373.196 130.379 C 373.980 129.809,374.645 129.374,374.674 129.411 C 374.703 129.449,375.133 130.089,375.629 130.833 C 379.474 136.604,382.599 138.348,386.476 136.886 C 390.507 135.366,391.524 132.443,389.922 126.979 C 388.177 121.025,388.289 122.240,388.126 107.500 C 387.950 91.671,387.626 89.430,384.932 85.378 C 380.974 79.427,370.390 76.580,357.314 77.946 M84.667 89.370 C 92.072 91.264,96.076 98.926,95.392 109.896 C 94.770 119.874,89.406 126.123,81.458 126.128 C 73.761 126.133,68.780 121.063,67.409 111.827 C 65.240 97.218,73.472 86.506,84.667 89.370 M255.465 89.361 C 262.435 91.143,266.313 97.681,266.287 107.604 C 266.256 119.045,260.977 126.083,252.396 126.123 C 243.308 126.165,237.983 119.220,238.037 107.396 C 238.096 94.504,245.524 86.818,255.465 89.361 M373.340 114.375 C 372.414 122.459,366.776 127.500,358.661 127.500 C 349.487 127.500,346.101 117.532,353.870 113.398 C 355.277 112.650,356.392 112.347,363.653 110.745 C 368.684 109.634,373.030 108.498,373.305 108.222 C 373.546 107.980,373.570 112.361,373.340 114.375 " stroke="none" fill="#04b48c" fill-rule="evenodd"/><path id="path1" d="" stroke="none" fill="#08b48c" fill-rule="evenodd"/><path id="path2" d="" stroke="none" fill="#08b48c" fill-rule="evenodd"/><path id="path3" d="" stroke="none" fill="#08b48c" fill-rule="evenodd"/><path id="path4" d="" stroke="none" fill="#08b48c" fill-rule="evenodd"/></g></svg>
                  </Link>
                </div>
              </div>
              
              <div className="hidden md:block w-5/6">
                <div className="flex flex-grow justify-center flex-wrap items-center">
                  <ul id="header-menu" className="header-text-color flex flex-grow w-2/4 justify-center">
                    <li className="relative" onMouseEnter={() => setIsProductsOpen(true)} onMouseLeave={() => setIsProductsOpen(false)}>
                      <div className="font-small px-5 py-3 flex items-center transition duration-150 ease-in-out cursor-pointer">
                        Products
                      </div>
                      {isProductsOpen && (
                        <ul className="absolute left-0 w-72 bg-white border border-gray-200 rounded-lg shadow-xl">
                          <li>
                            <Link onClick={goTeams} className="block group px-4 py-3 rounded-t-lg hover:bg-gray-200 flex justify-between items-center">
                              <div>
                                <div className="flex">
                                  <h1 className="text-myblue-900 font-semibold">Routora for Teams</h1>
                                  <div style={{ padding: "3px 5px 0px 5px", marginTop: 2, fontSize: "11px" }} className="text-myteal-500 font-semibold bg-myteal-200 ml-2 rounded">NEW</div>
                                </div>
                                <p className="text-gray-500 text-sm">Fleet route management</p>
                              </div>
                              <div className="text-white group-hover:text-gray-500 flex items-center">
                                <svg className="w-3 h-3 fill-current flex-shrink-0" fill="currentColor" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z" fillRule="nonzero" />
                                </svg>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to="/playground" className="block group px-4 py-3 hover:bg-gray-200 flex justify-between items-center">
                              <div>
                                <h1 className="text-myblue-900 font-semibold">Web Route Planner</h1>
                                <p className="text-gray-500 text-sm">Individual route planner</p>
                              </div>
                              <div className="text-white group-hover:text-gray-500 flex items-center">
                                <svg className="w-3 h-3 fill-current flex-shrink-0" fill="currentColor" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z" fillRule="nonzero" />
                                </svg>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={goAppInstall} className="block group px-4 py-3 hover:bg-gray-200 flex justify-between items-center">
                              <div>
                                <h1 className="text-myblue-900 font-semibold">Mobile App</h1>
                                <p className="text-gray-500 text-sm">Driver app on iOS/Android</p>
                              </div>
                              <div className="text-white group-hover:text-gray-500 flex items-center">
                                <svg className="w-3 h-3 fill-current flex-shrink-0" fill="currentColor" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z" fillRule="nonzero" />
                                </svg>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={goExtension} className="block group px-4 py-3 rounded-b-lg hover:bg-gray-200 flex justify-between items-center">
                              <div>
                                <h1 className="text-myblue-900 font-semibold">Chrome Extension</h1>
                                <p className="text-gray-500 text-sm">Google Maps route optimizer</p>
                              </div>
                              <div className="text-white group-hover:text-gray-500 flex items-center">
                                <svg className="w-3 h-3 fill-current flex-shrink-0" fill="currentColor" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z" fillRule="nonzero" />
                                </svg>
                              </div>
                            </Link>
                          </li>

                        </ul>
                      )}
                    </li>
                    <li>
                      <Link to="/pricing" className="font-small px-5 py-3 flex items-center transition duration-150 ease-in-out">Pricing</Link>
                    </li>
                    <li>
                      <Link to="/blog-main" className="font-small px-5 py-3 flex items-center transition duration-150 ease-in-out">Blog</Link>
                    </li>
                  </ul>

                  {currentUser ? (
                    <ul className="flex flex-grow w-2/6 justify-end">
                      <li>
                        <div onClick={onSignOutClick} id="header-signin" className="header-signin-color font-medium px-5 py-3 flex items-center transition duration-150 ease-in-out cursor-pointer">Sign out</div>
                      </li>

                      <li>
                        <div onClick={goProfile} id="corner-button" className="corner-button-color btn-sm ml-3 cursor-pointer">
                          <span>{userText}</span>
                          {currentUser.photoURL ? (
                            <img className="w-6 h-6 ml-2 rounded-full"
                              alt=""
                              src={currentUser.photoURL}
                            />
                          ) : (
                            <div style={{paddingTop: 1}} onClick={goProfile} className="w-6 h-6 ml-2 bg-myteal-500 rounded-full flex justify-center cursor-pointer">{userFirstChar}</div>
                          )}       
                        </div>
                      </li>
                    </ul>
                  ) : (
                    <ul className="flex flex-grow w-2/4 justify-end flex-wrap items-center">
                      <li>
                        <Link to="/signin" id="header-signin" className="header-signin-color font-medium hover:text-gray-900 px-5 py-3 flex items-center transition duration-150 ease-in-out">Sign in</Link>
                      </li>

                      <li>
                        <div onClick={goSignup} id="corner-button" className="corner-button-color btn-sm ml-3 cursor-pointer">
                          <span>Get Started</span>
                          <svg className="w-3 h-3 fill-current text-gray-400 flex-shrink-0 ml-2 -mr-1" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z" fillRule="nonzero" />
                          </svg>                  
                        </div>
                      </li>
                    </ul>
                  )}
                  
                </div>
              </div>

            <div className="-mr-2 flex md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                id="mobile-menu-button"
                className="menu-button-color inline-flex items-center justify-center p-2 rounded-md text-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {!isOpen ? (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                ) : (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <Transition
          show={isOpen}
          enter="transition ease-out duration-100 transform"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-75 transform"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {(ref) => (
            <div className="md:hidden" id="mobile-menu">
              <div ref={ref} className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white">
                <Link
                  to="/"
                  className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
                >
                  Home
                </Link>

                <div onClick={() => setIsProductsOpen(!isProductsOpen)} className="cursor-pointer text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium flex justify-between items-center">
                  <span>Products</span>
                  <svg
                    className={`h-5 w-5 transition-transform duration-200 ${isProductsOpen ? 'transform rotate-180' : ''}`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                {isProductsOpen && (
                  <div className="pl-4 space-y-1">
                    <Link onClick={goTeams} className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer">Routora for Teams</Link>
                    <Link to="/playground" className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer">Web Route Planner</Link>
                    <Link onClick={goAppInstall} className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer">Mobile App</Link>
                    <Link onClick={goExtension} className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer">Chrome Extension</Link>
                  </div>
                )}


                <Link
                  to="/pricing"
                  className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
                >
                  Pricing
                </Link>

                <Link
                  to="/blog-main"
                  className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
                >
                  Blog
                </Link>

                {currentUser ? (
                  <div>
                    <div
                      onClick={onSignOutClick}
                      className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
                    >
                      Sign out
                    </div>

                    <div
                      onClick={goProfile}
                      className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
                    >
                      Profile
                    </div>
                  </div>
                ) : (
                  <div>
                    <Link
                      to="/signin"
                      className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
                    >
                      Sign in
                    </Link>

                    <div
                      onClick={goSignup}
                      className="text-gray-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
                    >
                      Get Started
                    </div>
                  </div>
                )}
                
              </div>

            </div>
          )}
        </Transition>
      </nav>
    </header>
  );
}

export default Header;
